import BaseModel from './Model'
import store from '../../../store'
import radio from '../../../plugins/bus'
import http from '../client'

BaseModel.$http = http(store, radio)

class Model extends BaseModel {
  primaryKey () {
    return 'id'
  }

  displayErrors (field) {
    if (!this.errors) {
      return []
    }
    return this.errors
      .filter(obj => obj.field === field)
      .map(obj => obj.message)
      .flat()
  }

  errorsText () {
    if (!this.errors) {
      return []
    }
    return this.errors
      .map(obj => obj.message)
      .flat()
      .join('<br/>')
  }

  parse (response) {
    let data = response && response.data
    if (response.data.data) {
      data = response.data.data
    }

    if (response && response.data && response.data.meta) {
      this.pagination = response.data.meta
    }

    return {
      data: data || {}
    }
  }

  massDelete (ids) {
    if (!ids || !ids.length) {
      return
    }

    return this.request({
      method: 'DELETE',
      url: `${this.endpoint()}`,
      data: { ids: ids }
    })
  }

  request (config) {
    return super.request(config).catch(error => {
      radio.$emit('api-error', { error })
      throw error
    })
  }
}

export {
  Model
}
